import { Component, inject, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { ContentService } from '../../../../core/services/content.service';
import { NewsCardData, toNewsCardData } from '../../../../shared/utils/content-card.mapper';
import { pollSilently } from '../../../../shared/utils/silent-polling';
import { LocalizedDatePipe } from '../../../../shared/pipes/localized-date.pipe';
import { ScrollReveal } from '../../../../shared/directives/scroll-reveal';

interface NewsListItem extends NewsCardData {
  slug: string;
}

/** Liste publique des actualités (content-service, /contents/public/news). */
@Component({
  selector: 'app-news-list',
  imports: [RouterLink, ScrollReveal, TranslatePipe, LocalizedDatePipe],
  templateUrl: './news-list.html',
})
export class NewsList {
  private readonly contentService = inject(ContentService);

  readonly items = signal<NewsListItem[]>([]);
  readonly loading = signal(true);
  readonly error = signal(false);

  constructor() {
    this.load();
    // Rafraîchissement silencieux : les nouvelles actualités publiées apparaissent sans que le
    // visiteur ait à recharger la page.
    pollSilently(() => this.load(true));
  }

  private load(silent = false): void {
    if (!silent) this.loading.set(true);
    this.contentService.news().subscribe({
      next: (page) => {
        this.items.set(page.content.map((item) => ({ ...toNewsCardData(item), slug: item.slug })));
        this.loading.set(false);
      },
      error: () => {
        if (!silent) {
          this.loading.set(false);
          this.error.set(true);
        }
      },
    });
  }
}
